import React from 'react';
import Pagination from "react-js-pagination";
import { GoChevronLeft } from "react-icons/go";
import { GoChevronRight } from "react-icons/go";
const CustomPagination = props => {
  const {
    onPageChange,
    totalCount,
    currentPage,
    pageSize
  } = props;
  return (
    <Pagination
      hideFirstLastPages
      innerClass="pagination-container pagination-bar"
      itemClass="pagination-item"
      linkClass="page-link"
      prevPageText={<div className="pagination-arrow"><GoChevronLeft /></div>}
      nextPageText={<div className="pagination-arrow"><GoChevronRight /></div>}	
      activePage={currentPage}
      itemsCountPerPage={pageSize}
      totalItemsCount={totalCount}
      pageRangeDisplayed={5}
      onChange={onPageChange}
    />
  );
};

export default CustomPagination;
